export var FALLBACK_INTERVAL = 30 * 1000;
export var FORMAT_DATE_HOUR_MINUTE = "MM/DD h:mm A";
export var FORMAT_HOUR_MINUTE = "h:mm A";
export var FORMAT_LONG_DATE = "dddd, MMMM D";
export var SYNTHETIC_BRAND_VACATION_TOKEN = "mm_brand_vacation";
export var SYNTHETIC_SUPPORT_TOKEN = "mm_support_text";
export var SYNTHETIC_OTHER_PARTY_STATUS_TOKEN = "mm_other_party_status";
export var SYNTHETIC_MESSAGE_TOKENS = [
    SYNTHETIC_BRAND_VACATION_TOKEN,
    SYNTHETIC_SUPPORT_TOKEN,
    SYNTHETIC_OTHER_PARTY_STATUS_TOKEN
];
export var SYNTHETIC_SUPPORT_MESSAGE = function(strictLocalize) {
    return strictLocalize({
        id: "tk2rPt",
        defaultMessage: [
            {
                type: 0,
                value: "Have a question about Faire? We're online from 10am-3pm PST, Monday through Friday."
            }
        ]
    });
};
export var MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export var fadeColor = function(hexColor, opacityValue) {
    var opacityHexValue = Math.round(opacityValue * 255).toString(16);
    return "".concat(hexColor).concat(opacityHexValue);
};
